import * as React from "react";
import * as value from '../../../common';
import * as common from '../common';
import { Container as ContainerStrap } from 'reactstrap';

export * from './col';
export * from './row';

export interface IContainerLayoutProps extends common.ILayoutPropsBase {
    isFluid?: value.FuncValue<boolean>;
}

export const Container = (props: IContainerLayoutProps) => {
    return <ContainerStrap {...props}>
        {
            props.children
        }
    </ ContainerStrap>;
};

export interface IFluidContainerLayoutProps extends common.ILayoutPropsBase {
}

export const FluidContainer = (props: IFluidContainerLayoutProps) => {
    return <ContainerStrap fluid {...props}>
        {
            props.children
        }
    </ContainerStrap>;
};
